"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Breadcrumbs = /** @class */ (function (_super) {
    __extends(Breadcrumbs, _super);
    function Breadcrumbs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildItems = function (links) {
            return links
                ? links.map(function (link, i) { return (React.createElement(React.Fragment, { key: i },
                    React.createElement("li", { className: "block pr-0-5" }, i !== links.length - 1 ? (React.createElement("a", { href: link.url, title: link.title, className: "block no-underline transition-fast text-navy-dark hover:text-navy" }, link.title)) : (React.createElement("span", { className: "block text-navy" }, link.title))),
                    i < links.length - 1 ? (React.createElement("li", { className: "block pr-0-5" + (i == links.length - 2 ? " text-secondary-blue-grey" : "") }, _this.props.data.breadcrumbs.divider)) : null)); })
                : [];
        };
        _this.buildLastItem = function (links) {
            return links && links.length > 1
                ? links.map(function (link, i) {
                    return i === links.length - 2 ? (React.createElement("a", { key: i, href: link.url, title: link.title, className: "flex items-center justify-start no-underline transition-fast text-charcoal hover:text-midnight" },
                        React.createElement(Snippets.Svg, { name: "arrow-left", width: 24, className: "block mr-0-4" }),
                        React.createElement("p", { className: "text-xs" }, link.title))) : null;
                })
                : null;
        };
        return _this;
    }
    Breadcrumbs.prototype.render = function () {
        return (React.createElement("section", { className: "" + (this.props.collapsed ? "block" : "md:block") + (this.props.className ? " " + this.props.className : "") },
            React.createElement("ul", { className: "list-reset items-center justify-start text-xs font-normal text-charcoal " + (this.props.collapsed ? "hidden md:flex" : "flex") }, this.buildItems(this.props.links ? this.props.links : this.props.data.breadcrumbs.links)),
            this.props.collapsed ? (React.createElement("div", { className: "block md:hidden" }, this.buildLastItem(this.props.links ? this.props.links : this.props.data.breadcrumbs.links))) : null));
    };
    return Breadcrumbs;
}(React.PureComponent));
exports.Breadcrumbs = Breadcrumbs;
